import "core-js/modules/es6.promise";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * Maintains a promise that will be unresolved when "busy" and resolved when "not busy".
 * Set the busy status by calling start(), then call the returned function when done.
 *
 * @example
 *     const indicator = new BusyIndicator();
 *     const done = indicator.start();
 *     doSomeWork().finally(done);
 *
 * @property {Promise} promise - The promise to pass to cgBusy, indicating this BusyIndicator is active
*/
var BusyIndicator =
/*#__PURE__*/
function () {
  function BusyIndicator() {
    _classCallCheck(this, BusyIndicator);

    this._stack = [];
  }
  /**
   * Ensures this BusyIndicator will be "busy" until the returned function is called.
   * @returns {Function} - Call this function to indicate you are no longer busy.
   */


  _createClass(BusyIndicator, [{
    key: "start",
    value: function start() {
      var _this = this;

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      // The arguments are used as an identity, so we know when we are
      // popping "this" operation from the stack.
      this._stack.push(args);

      if (this._stack.length == 1) {
        // This is the promise that cgBusy should monitor
        this.promise = new Promise(function (resolve) {
          _this._resolve = resolve;
        });
      }

      return function () {
        return _this._stop(args);
      };
    }
  }, {
    key: "_stop",
    value: function _stop(args) {
      var ix = this._stack.indexOf(args);

      if (ix > -1) {
        this._stack.splice(ix, 1);

        if (this._stack.length == 0) {
          this._resolve();
        }
      }
    }
    /**
     * Forces the BusyIndicator to move to the "not busy" state.
     * This is not normally required.
     */

  }, {
    key: "cancel",
    value: function cancel() {
      var shouldResolve = this._stack.length > 0;
      this._stack = [];

      if (shouldResolve) {
        this._resolve();
      }
    }
  }]);

  return BusyIndicator;
}();

export { BusyIndicator as default };